module.exports = __webpack_public_path__ + "media/entities/2902-e77ecb75.png";